import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent]
})
export class InfoBoxComponent {}
